/*
  Charm-Konfigurator (ersetzt Easify Options)
  - Live-Vorschau: Kettenfoto der gewählten Variante + Charm-Ebenen an festen Plätzen
  - Beim „In den Warenkorb“: Eigenschaften + Vorschau-Bild an die Kette hängen,
    Aufpreis-Zeile(n) vorher in den Warenkorb legen, dann normal weiter mit Dawn.
*/
if (!customElements.get('sd-konfigurator')) {
  const VORSCHAU_GROESSE = 800;

  const formatiereGeld = (cent, format) => {
    const betrag = (cent / 100).toFixed(2);
    const [ganz, rest] = betrag.split('.');
    const mitPunkt = ganz.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const mitKomma = ganz.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '{{amount_with_comma_separator}} €').replace(/\{\{\s*(\w+)\s*\}\}/, (_, art) => {
      if (art === 'amount_with_comma_separator') return `${mitPunkt},${rest}`;
      if (art === 'amount_no_decimals_with_comma_separator') return mitPunkt;
      if (art === 'amount_no_decimals') return mitKomma;
      return `${mitKomma}.${rest}`;
    });
  };

  const ladeBild = (src) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });

  // Vorschaubild für Kacheln: Charm-Ebene auf den sichtbaren Charm zuschneiden (quadratisch, mit Rand),
  // damit auch große Charms (Delfin, Sanddollar …) ganz in die Kachel passen. Ergebnis wird gemerkt.
  const zuschnitte = new Map();
  const schneideZu = (src) => {
    if (zuschnitte.has(src)) return zuschnitte.get(src);
    const ergebnis = ladeBild(src)
      .then((bild) => {
        const g = 300;
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = g;
        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(bild, 0, 0, g, g);
        const pixel = ctx.getImageData(0, 0, g, g).data;
        let links = g, oben = g, rechts = -1, unten = -1;
        for (let y = 0; y < g; y++) {
          for (let x = 0; x < g; x++) {
            if (pixel[(y * g + x) * 4 + 3] > 20) {
              if (x < links) links = x;
              if (x > rechts) rechts = x;
              if (y < oben) oben = y;
              if (y > unten) unten = y;
            }
          }
        }
        if (rechts < 0) return src;
        const seite = Math.max(rechts - links, unten - oben) * 1.12;
        const mx = (links + rechts) / 2;
        const my = (oben + unten) / 2;
        const aus = document.createElement('canvas');
        aus.width = aus.height = 240;
        const s = bild.naturalWidth / g;
        aus
          .getContext('2d')
          .drawImage(bild, (mx - seite / 2) * s, (my - seite / 2) * s, seite * s, seite * s, 0, 0, 240, 240);
        return aus.toDataURL('image/png');
      })
      .catch(() => src);
    zuschnitte.set(src, ergebnis);
    return ergebnis;
  };

  const setzeZuschnitt = (img, src) => {
    schneideZu(src).then((url) => {
      if (img.dataset.quelle === src) img.src = url;
    });
  };

  const neueId = () => `sd${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;

  class SdKonfigurator extends HTMLElement {
    connectedCallback() {
      if (this.bereit) return;
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.bereit = true;

      this.daten = JSON.parse(this.querySelector('[data-sd-daten]').textContent);

      this.zustand = {
        laenge: this.querySelector('input[name^="sd-laenge"]:checked').value,
        anzahl: Number(this.querySelector('input[name^="sd-anzahl"]:checked').value),
        auswahl: {},
        aktiv: null,
      };

      this.vorschauen = [...this.querySelectorAll('[data-sd-vorschau]')];
      this.platzListe = this.querySelector('[data-sd-plaetze]');
      this.raster = this.querySelector('[data-sd-raster]');
      this.fehler = this.querySelector('[data-sd-fehler]');

      this.setzeFarbe(this.variante.farbe);
      this.verschiebeVorschau();
      this.binde();
      this.aktualisiere();
    }

    // Übersetzter Text aus locales/*.json (sd_konfigurator.*), Platzhalter wie {{ name }} werden ersetzt.
    t(schluessel, werte = {}) {
      const text = (this.daten.texte && this.daten.texte[schluessel]) || schluessel;
      return text.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, name) => (name in werte ? werte[name] : ''));
    }

    // Beschriftung eines Platzes in der Shop-Sprache (Mitte / links / rechts)
    platzName(platz) {
      return this.t({ m: 'mitte', l: 'links', r: 'rechts' }[this.spots[platz].seite]);
    }

    get variantId() {
      return this.form.querySelector('input[name="id"]')?.value;
    }

    get variante() {
      return this.daten.varianten[this.variantId] || Object.values(this.daten.varianten)[0];
    }

    get aktivePlaetze() {
      return this.layouts[String(this.zustand.anzahl)] || [];
    }

    get zusatzCharms() {
      return Math.max(0, this.zustand.anzahl - 1);
    }

    get menge() {
      const feld = document.querySelector(`input[name="quantity"][form="${this.form.id}"]`);
      return Math.max(1, parseInt(feld?.value, 10) || 1);
    }

    binde() {
      this.querySelectorAll('input[name^="sd-laenge"]').forEach((input) =>
        input.addEventListener('change', () => {
          this.zustand.laenge = input.value;
          this.aktualisiere();
        })
      );
      this.querySelectorAll('input[name^="sd-anzahl"]').forEach((input) =>
        input.addEventListener('change', () => {
          this.zustand.anzahl = Number(input.value);
          this.zustand.aktiv = null;
          this.aktualisiere();
        })
      );

      // Dawn setzt die Varianten-ID neu und löst „change“ aus, wenn der Kettenstil wechselt.
      this.form.addEventListener('change', (event) => {
        if (event.target.name !== 'id') return;
        if (!event.target.value) {
          // Farbwechsel auf eine Kombination, die es nicht gibt (z. B. Silber + „Dünn mit Kugeln“):
          // ersten Kettenstil wählen, den es in der neuen Farbe gibt.
          setTimeout(() => this.waehleErstenVorhandenenStil());
          return;
        }
        this.aktualisiere();
      });
      document.addEventListener('change', (event) => {
        if (event.target.name === 'quantity') this.zeigeSumme();
      });

      // Vor Dawn eingreifen: Erfassungsphase am <product-form>-Element.
      const produktForm = this.form.closest('product-form') || this.form;
      produktForm.addEventListener('submit', (event) => this.beimAbsenden(event), true);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartError, () => window.sdWarenkorbPruefen?.());
      }
    }

    waehleErstenVorhandenenStil() {
      const auswahl = this.form.closest('product-info')?.querySelector('variant-selects');
      if (!auswahl) return;
      const offen = [...auswahl.querySelectorAll('fieldset')].find(
        (gruppe) => !gruppe.querySelector('input:checked') && gruppe.querySelector('input')
      );
      const erster = offen?.querySelector('input');
      if (!erster) return;
      erster.checked = true;
      erster.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Die große Vorschau ersetzt die Bildergalerie in der linken Spalte.
    verschiebeVorschau() {
      const gross = this.querySelector('.sd-vorschau--gross') || this.grosseVorschau;
      this.grosseVorschau = gross;
      const bildSpalte = this.closest('.product')?.querySelector('.product__media-wrapper');
      if (!bildSpalte || !gross) return;
      bildSpalte.classList.add('sd-hat-vorschau');
      if (gross.parentElement !== bildSpalte) bildSpalte.prepend(gross);
    }

    // Charm-Auswahl, Plätze und Positionen der Farbe laden. Bereits gewählte Charms
    // bleiben, wenn es sie in der neuen Farbe auch gibt (gleicher Name).
    setzeFarbe(farbe) {
      const daten = this.daten.charmDaten[farbe] || this.daten.charmDaten.silber;
      const alteCharms = this.charms || [];
      this.farbe = farbe;
      this.farbDaten = daten;
      this.charms = [...daten.charms].sort((a, b) => a.reihenfolge - b.reihenfolge);
      this.spots = daten.spots;
      this.layouts = daten.layouts;
      Object.keys(this.zustand.auswahl).forEach((platz) => {
        const name = alteCharms[this.zustand.auswahl[platz]]?.name;
        const neu = this.charms.findIndex((charm) => charm.name === name && charm.verfuegbar);
        if (neu >= 0) this.zustand.auswahl[platz] = neu;
        else delete this.zustand.auswahl[platz];
      });
      this.baueRaster();
    }

    baueRaster() {
      this.raster.innerHTML = '';
      this.charms.forEach((charm, index) => {
        const knopf = document.createElement('button');
        knopf.type = 'button';
        knopf.className = 'sd-charm';
        knopf.dataset.index = index;
        knopf.setAttribute('aria-pressed', 'false');
        knopf.innerHTML = `<span class="sd-charm__bild"><img alt="" width="240" height="240"></span><span class="sd-charm__name"></span>`;
        knopf.querySelector('.sd-charm__name').textContent = charm.name;
        const kachelBild = knopf.querySelector('img');
        kachelBild.dataset.quelle = charm.bild;
        setzeZuschnitt(kachelBild, charm.bild);
        if (!charm.verfuegbar) {
          // Lagerartikel leer: sichtbar, aber nicht wählbar.
          knopf.disabled = true;
          knopf.classList.add('sd-charm--vergriffen');
          const hinweis = document.createElement('span');
          hinweis.className = 'sd-charm__hinweis';
          hinweis.textContent = this.t('vergriffen');
          knopf.append(hinweis);
        }
        knopf.addEventListener('click', () => this.waehleCharm(index));
        this.raster.append(knopf);
      });
    }

    waehleCharm(index) {
      const plaetze = this.aktivePlaetze;
      if (!plaetze.length) return;
      const aktiv = this.zustand.aktiv || plaetze.find((p) => this.zustand.auswahl[p] == null) || plaetze[0];
      this.zustand.auswahl[aktiv] = index;
      // Danach automatisch zum nächsten freien Platz springen.
      const naechster = plaetze.find((p) => this.zustand.auswahl[p] == null);
      this.zustand.aktiv = naechster || aktiv;
      this.zeigeFehler('');
      this.aktualisiere();
    }

    aktualisiere() {
      if (this.variante.farbe !== this.farbe) this.setzeFarbe(this.variante.farbe);
      const plaetze = this.aktivePlaetze;
      if (!plaetze.includes(this.zustand.aktiv)) {
        this.zustand.aktiv = plaetze.find((p) => this.zustand.auswahl[p] == null) || plaetze[0] || null;
      }
      this.querySelector('[data-sd-charmbereich]').hidden = plaetze.length === 0;
      this.zeigePlaetze();
      this.zeigeRaster();
      this.zeigeVorschau();
      this.zeigeSumme();
    }

    zeigePlaetze() {
      const plaetze = this.aktivePlaetze;
      this.platzListe.innerHTML = '';
      plaetze.forEach((platz) => {
        const knopf = document.createElement('button');
        knopf.type = 'button';
        knopf.className = 'sd-platz';
        const index = this.zustand.auswahl[platz];
        const charm = index != null ? this.charms[index] : null;
        knopf.setAttribute('aria-pressed', String(platz === this.zustand.aktiv));
        knopf.innerHTML = `<span class="sd-platz__bild">${
          charm ? '<img alt="" width="240" height="240">' : '<span>+</span>'
        }</span><span class="sd-platz__name"></span>`;
        knopf.querySelector('.sd-platz__name').textContent = this.platzName(platz);
        if (charm) {
          const platzBild = knopf.querySelector('img');
          platzBild.dataset.quelle = charm.bild;
          setzeZuschnitt(platzBild, charm.bild);
        }
        knopf.setAttribute(
          'aria-label',
          this.t('platz_aria', { platz: this.platzName(platz), charm: charm ? charm.name : this.t('kein_charm') })
        );
        knopf.addEventListener('click', () => {
          this.zustand.aktiv = platz;
          this.aktualisiere();
        });
        this.platzListe.append(knopf);
      });

      const hinweis = this.querySelector('[data-sd-platzhinweis]');
      hinweis.textContent =
        plaetze.length > 1 && this.zustand.aktiv
          ? this.t({ m: 'hinweis_mitte', l: 'hinweis_links', r: 'hinweis_rechts' }[this.spots[this.zustand.aktiv].seite])
          : '';
    }

    zeigeRaster() {
      const aktivIndex = this.zustand.auswahl[this.zustand.aktiv];
      this.raster.querySelectorAll('.sd-charm').forEach((knopf) => {
        knopf.setAttribute('aria-pressed', String(Number(knopf.dataset.index) === aktivIndex));
      });
    }

    // Ebenen in der Reihenfolge der Plätze; die Mitte liegt vorne.
    ebenen() {
      return this.aktivePlaetze
        .filter((platz) => this.zustand.auswahl[platz] != null)
        .sort((a, b) => (a === 'C') - (b === 'C'))
        .map((platz) => ({ spot: this.spots[platz], charm: this.charms[this.zustand.auswahl[platz]] }));
    }

    zeigeVorschau() {
      const { leinwand, feld } = this.farbDaten;
      const ebenen = this.ebenen();
      this.vorschauen.forEach((vorschau) => {
        const kette = vorschau.querySelector('.sd-vorschau__kette');
        if (kette.getAttribute('src') !== this.variante.bild) kette.src = this.variante.bild;
        const container = vorschau.querySelector('.sd-vorschau__ebenen');
        container.innerHTML = '';
        ebenen.forEach(({ spot, charm }) => {
          const img = document.createElement('img');
          img.src = charm.bild;
          img.alt = '';
          img.className = 'sd-vorschau__charm';
          img.style.left = `${(spot.x / leinwand) * 100}%`;
          img.style.top = `${(spot.y / leinwand) * 100}%`;
          img.style.width = `${(feld / leinwand) * 100}%`;
          img.style.transform = `rotate(${spot.r}deg)`;
          container.append(img);
        });
      });
      const gross = this.grosseVorschau?.querySelector('.sd-vorschau__kette');
      if (gross) {
        const namen = ebenen.map(({ charm }) => charm.name).join(', ');
        gross.alt = `${this.t('vorschau')}: ${this.variante.titel}${namen ? ` ${this.t('mit')} ${namen}` : ''}`;
      }
    }

    aufpreisCent() {
      const { charm, laenge } = this.daten.aufpreis;
      let summe = 0;
      if (charm) summe += this.zusatzCharms * charm.preis;
      if (laenge && this.zustand.laenge === '50 cm') summe += laenge.preis;
      return summe;
    }

    zeigeSumme() {
      const format = this.daten.geldformat;
      const basis = this.variante.preis;
      const aufpreis = this.aufpreisCent();
      this.querySelector('[data-sd-summe]').textContent = formatiereGeld((basis + aufpreis) * this.menge, format);

      const teile = [];
      if (this.zusatzCharms > 0 && this.daten.aufpreis.charm) {
        const text =
          this.zusatzCharms === 1 ? this.t('ein_weiterer') : this.t('weitere', { anzahl: this.zusatzCharms });
        teile.push(`${text} ${formatiereGeld(this.zusatzCharms * this.daten.aufpreis.charm.preis, format)}`);
      }
      if (this.zustand.laenge === '50 cm' && this.daten.aufpreis.laenge) {
        teile.push(`50 cm ${formatiereGeld(this.daten.aufpreis.laenge.preis, format)}`);
      }
      this.querySelector('[data-sd-detail]').textContent = teile.length
        ? `(${this.t('kette')} ${formatiereGeld(basis, format)} + ${teile.join(' + ')}${
            this.menge > 1 ? `, × ${this.menge}` : ''
          })`
        : this.menge > 1
        ? `(× ${this.menge})`
        : '';
    }

    zeigeFehler(text) {
      this.fehler.textContent = text;
      this.fehler.hidden = !text;
    }

    pruefe() {
      const fehlend = this.aktivePlaetze.filter((platz) => this.zustand.auswahl[platz] == null);
      if (fehlend.length) {
        this.zustand.aktiv = fehlend[0];
        this.aktualisiere();
        return fehlend.length === 1
          ? this.t('fehlt_einer')
          : this.t('fehlt_mehrere', { anzahl: fehlend.length });
      }
      // Bestand: gleicher Charm mehrfach gewählt und mehrere Ketten zählen zusammen.
      const benoetigt = {};
      this.aktivePlaetze.forEach((platz) => {
        const index = this.zustand.auswahl[platz];
        benoetigt[index] = (benoetigt[index] || 0) + this.menge;
      });
      for (const [index, anzahl] of Object.entries(benoetigt)) {
        const charm = this.charms[index];
        if (!charm.verfuegbar) return this.t('vergriffen_fehler', { name: charm.name });
        if (charm.bestand != null && anzahl > charm.bestand) {
          return this.t('bestand_fehler', { name: charm.name, anzahl: charm.bestand });
        }
      }
      if (this.zusatzCharms > 0 && !this.daten.aufpreis.charm) return this.t('nicht_verfuegbar');
      if (this.zustand.laenge === '50 cm' && !this.daten.aufpreis.laenge)
        return this.t('nicht_verfuegbar');
      return '';
    }

    async beimAbsenden(event) {
      if (this.durchlassen) {
        this.durchlassen = false;
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();

      const knopf = this.form.querySelector('[type="submit"]');
      if (!knopf || knopf.disabled || knopf.getAttribute('aria-disabled') === 'true' || this.laeuft) return;

      const fehler = this.pruefe();
      if (fehler) {
        this.zeigeFehler(fehler);
        this.querySelector('[data-sd-charmbereich]').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      this.zeigeFehler('');

      this.laeuft = true;
      knopf.classList.add('loading');
      knopf.querySelector('.loading__spinner')?.classList.remove('hidden');
      try {
        const id = neueId();
        await this.schreibeEigenschaften(id);
        await this.legeAufpreisInWarenkorb(id);
        knopf.classList.remove('loading');
        this.durchlassen = true;
        this.form.requestSubmit(knopf);
      } catch (fehler) {
        console.error(fehler);
        this.zeigeFehler(this.t('fehler_allgemein'));
        knopf.classList.remove('loading');
        knopf.querySelector('.loading__spinner')?.classList.add('hidden');
      } finally {
        this.laeuft = false;
      }
    }

    // Eigenschaften der Kette (Line-Item-Properties). Mit „_“ = nur für uns sichtbar.
    async schreibeEigenschaften(id) {
      this.form.querySelectorAll('[data-sd-feld]').forEach((feld) => feld.remove());
      document.querySelectorAll(`[data-sd-feld][form="${this.form.id}"]`).forEach((feld) => feld.remove());

      const felder = {};
      // Sichtbare Felder in der Shop-Sprache; versteckte Felder (mit „_“) immer gleich, damit der Charm-Abgleich sie lesen kann.
      felder[this.t('prop_laenge')] = this.zustand.laenge;
      const plaetze = this.aktivePlaetze;
      if (plaetze.length) {
        const sortiert = [...plaetze].sort((a, b) => this.spots[a].x - this.spots[b].x);
        felder[this.t('prop_charms')] = sortiert
          .map((platz) => `${this.charms[this.zustand.auswahl[platz]].name} (${this.platzName(platz)})`)
          .join(', ');
        sortiert.forEach((platz) => {
          const deutsch = { m: 'Mitte', l: 'links', r: 'rechts' }[this.spots[platz].seite];
          felder[`_Charm ${deutsch}`] = this.charms[this.zustand.auswahl[platz]].id;
        });
      }
      felder['_Anzahl der Charms'] = String(this.zustand.anzahl);
      // Lagerartikel je Charm (für den Charm-Abgleich), z. B. "57477893587209,57477893619977"
      const lager = plaetze.map((platz) => this.charms[this.zustand.auswahl[platz]].lager).filter(Boolean);
      if (lager.length) felder['_sd_lager'] = lager.join(',');
      felder['_sd_id'] = id;

      const aufpreis = [];
      if (this.zusatzCharms > 0) aufpreis.push(`${this.daten.aufpreis.charm.id}:${this.zusatzCharms}`);
      if (this.zustand.laenge === '50 cm') aufpreis.push(`${this.daten.aufpreis.laenge.id}:1`);
      if (aufpreis.length) felder['_sd_aufpreis'] = aufpreis.join(',');

      Object.entries(felder).forEach(([name, wert]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${name}]`;
        input.value = wert;
        input.dataset.sdFeld = '';
        this.form.append(input);
      });

      // Vorschau-Bild als Datei mitschicken (landet bei Shopify unter /uploads/).
      try {
        const blob = await this.erzeugeVorschau();
        const datei = new File([blob], 'vorschau.jpg', { type: 'image/jpeg' });
        const uebergabe = new DataTransfer();
        uebergabe.items.add(datei);
        const input = document.createElement('input');
        input.type = 'file';
        input.name = 'properties[_Vorschau]';
        input.hidden = true;
        input.dataset.sdFeld = '';
        input.files = uebergabe.files;
        this.form.append(input);
      } catch (fehler) {
        // Ohne Vorschau-Bild geht die Bestellung trotzdem durch.
        console.warn('Vorschau-Bild konnte nicht erzeugt werden', fehler);
      }
    }

    async erzeugeVorschau() {
      const { leinwand, feld } = this.farbDaten;
      const s = VORSCHAU_GROESSE / leinwand;
      const canvas = document.createElement('canvas');
      canvas.width = canvas.height = VORSCHAU_GROESSE;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, VORSCHAU_GROESSE, VORSCHAU_GROESSE);
      ctx.drawImage(await ladeBild(this.variante.bild), 0, 0, VORSCHAU_GROESSE, VORSCHAU_GROESSE);
      for (const { spot, charm } of this.ebenen()) {
        const bild = await ladeBild(charm.bild);
        const groesse = feld * s;
        ctx.save();
        ctx.translate((spot.x + feld / 2) * s, (spot.y + feld / 2) * s);
        ctx.rotate((spot.r * Math.PI) / 180);
        ctx.drawImage(bild, -groesse / 2, -groesse / 2, groesse, groesse);
        ctx.restore();
      }
      return new Promise((resolve, reject) =>
        canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('leer'))), 'image/jpeg', 0.88)
      );
    }

    async legeAufpreisInWarenkorb(id) {
      const menge = this.menge;
      const fuer = `${this.daten.produkt} · ${this.variante.titel}`;
      const items = [];
      if (this.zusatzCharms > 0) {
        items.push({
          id: this.daten.aufpreis.charm.id,
          quantity: this.zusatzCharms * menge,
          properties: { [this.t('prop_fuer')]: fuer, _sd_fuer: id },
        });
      }
      if (this.zustand.laenge === '50 cm') {
        items.push({ id: this.daten.aufpreis.laenge.id, quantity: menge, properties: { [this.t('prop_fuer')]: fuer, _sd_fuer: id } });
      }
      if (!items.length) return;

      const antwort = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!antwort.ok) throw new Error(`Aufpreis: ${antwort.status}`);
    }
  }

  customElements.define('sd-konfigurator', SdKonfigurator);
}
